import { render, staticRenderFns } from "./TrackingForm.vue?vue&type=template&id=1d50dea5&"
import script from "./TrackingForm.vue?vue&type=script&lang=js&"
export * from "./TrackingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports